var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDramIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DRAM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,14.4439314 L20,11.7922164 L17.2192566,11.7922164 L17.2192566,9.00593668 C17.2192566,5.35686016 14.6198659,3 10.5989031,3 C6.65009141,3 4.07800122,5.28562005 4,8.83773087 L4,10.0448549 L6.63839122,10.0448549 L6.63839122,8.83773087 C6.80804388,6.67282322 8.3134674,5.33509235 10.5989031,5.33509235 C13.0695917,5.33509235 14.6042657,6.8469657 14.6042657,9.28298153 L14.6042657,11.7922164 L12.3032297,11.7922164 L12.3032297,14.4439314 L14.6042657,14.4439314 L14.6042657,15.6697509 L12.3032297,15.6697509 L12.3032297,18.321466 L14.6042657,18.321466 L14.6042657,21 L17.2192566,21 L17.2192566,18.321466 L20,18.321466 L20,15.6697509 L17.2192566,15.6697509 L17.2192566,14.4439314 L20,14.4439314 Z",
    id: "Fill-1",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDramIc);
export default __webpack_public_path__ + "static/media/dram_ic.0cd0237e.svg";
export { ForwardRef as ReactComponent };